import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { AppLayout } from "@/components/layout/app-layout";
import { ErrorFallback } from "@/components/feedback/error-fallback";
import { authQueryOptions } from "@/features/auth/auth-queries";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ context, location }) => {
    const user = await context.queryClient.ensureQueryData(authQueryOptions);
    if (!user) {
      throw redirect({
        to: "/",
        search: { login: true, redirect: location.href },
      });
    }
    return { auth: { user } };
  },
  component: AuthenticatedLayout,
  errorComponent: ({ error, reset }) => (
    <AppLayout>
      <ErrorFallback
        error={error instanceof Error ? error : new Error(String(error))}
        onReset={reset}
        variant="page"
      />
    </AppLayout>
  ),
});

function AuthenticatedLayout() {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
